module.exports = __webpack_public_path__ + "static/img/class_21.f077e833.jpg";